module.exports = __webpack_public_path__ + "static/media/DANGER_RAFFLE.a816dbd3.mp3";